import { MenuProps } from 'components/Menu/Types'
import { observer } from 'mobx-react-lite'
import { EditorColorPicker } from 'common/Prose/components/EditorColorPicker/EditorColorPicker'
import { DEFAULT_QUOTE_COLOR, QUOTE_COLOR_OPTIONS } from 'common/Prose/constants/colorOptions'
import { useQuoteButton } from 'components/DocRightRail/screens/FormatMenu/hooks/useQuoteButton'
import Styles from './ColorPicker.module.scss'

export const QuoteSubMenu = observer(({ onAction }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
  const { activeColors, setColor, removeColor } = useQuoteButton()

  return (
    <span className={Styles.root}>
      <EditorColorPicker
        aria-label={(color: string) => `Change quote color to ${color}`}
        colorOptions={QUOTE_COLOR_OPTIONS}
        activeColors={activeColors}
        setColor={setColor}
        removeColor={removeColor}
        defaultColor={DEFAULT_QUOTE_COLOR}
        noColorButtonPos="bottom"
        noColorButtonLabel="Remove"
        includeDropdownStyles={false}
      />
    </span>
  )
})
